// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"1e27e3a98dc687ed","9341":"6cce9822fb472f85"}[chunkId] + ".js";
};